"use client";

import React from "react";
import { Activity, ClipboardCheck, CircleDashed, Wrench, Droplet, Settings } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  title: "Diagnóstico de Celdas",
  copy: "Diagnóstico avanzado de celdas con análisis de resistencia interna y capacidad real en Sevilla, Mairena del Aljarafe y Aljarafe.",
  icon: Activity
}, {
  title: "Equilibrado de Voltaje",
  copy: "Equilibrado de voltaje y nivelación de series para garantizar la máxima autonomía operativa en Sevilla, Mairena del Aljarafe y Aljarafe.",
  icon: ClipboardCheck
}, {
  title: "Gestión de BMS",
  copy: "Gestión y programación de sistemas BMS para una electrónica inteligente y segura en Mairena del Aljarafe y Aljarafe.",
  icon: CircleDashed
}, {
  title: "Reconstrucción Total",
  copy: "Reconstrucción técnica integral con sustitución de celdas por componentes de alta calidad en Sevilla, Mairena del Aljarafe y Aljarafe.",
  icon: Wrench
}, {
  title: "Reparación de Packs",
  copy: "Reparación especializada de packs con soldadura de precisión y sellado estanco certificado en Mairena del Aljarafe y Aljarafe.",
  icon: Droplet
}, {
  title: "Mantenimiento Pro",
  copy: "Mantenimiento profesional preventivo para la optimización de ciclos de carga y descarga en Sevilla, Mairena del Aljarafe y Aljarafe.",
  icon: Settings
}];
export default function EspecialidadesTecnicas() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="86088" id="nuestros-servicios-técnicos-especializados" className="dark bg-background text-foreground py-24 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-screen-xl mx-auto relative z-10">
        <div ref={headerRef} className={`text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-6xl font-default tracking-tighter mb-4 uppercase">
            Servicios Técnicos <span className="text-primary">Especializados en Sevilla y Mairena del Aljarafe, Aljarafe</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-default">
            Nuestro laboratorio técnico en Sevilla proporciona soluciones de ingeniería avanzada para la restauración y optimización de baterías de litio con cobertura nacional. Atendemos de forma preferente en Mairena del Aljarafe y toda la zona del Aljarafe.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {servicesData.map((service, i) => {
          const {
            ref: cardRef,
            isVisible: isCardVisible
          } = useRevealOnScroll({
            threshold: 0.1
          });
          return <div key={i} data-index={i} ref={cardRef} className={`group relative bg-card/20 backdrop-blur-xl border border-white/10 rounded-2xl p-8 h-[320px] flex flex-col items-center justify-center overflow-hidden transition-all duration-700 ease-out cursor-default ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                {}
                <div className="absolute inset-0 bg-gradient-to-br from-transparent via-primary/5 to-primary/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

                {}
                <div className="relative z-10 flex flex-col items-center w-full transition-transform duration-500 group-hover:-translate-y-4">
                  {}
                  <div className="mb-6 transition-all duration-500 ease-out group-hover:[transform:rotateX(15deg)_rotateY(-15deg)_scale(1.1)] group-hover:drop-shadow-[0_0_20px_rgba(var(--color-primary),0.5)]">
                    <service.icon className="w-16 h-16 text-primary/70 group-hover:text-primary transition-colors duration-300" strokeWidth={1.5} />
                  </div>

                  <h3 className="text-2xl font-default text-primary text-center tracking-tight uppercase">
                    {service.title}
                  </h3>
                </div>

                {}
                <div className="absolute bottom-0 left-0 w-full p-6 translate-y-full opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 ease-out flex justify-center">
                  <div className="bg-background/80 backdrop-blur-md border border-primary/40 py-3 px-5 rounded-lg shadow-[0_0_25px_rgba(var(--color-primary),0.2)]">
                    <p className="text-xs md:text-sm text-foreground font-mono text-center tracking-tighter">
                      &gt; {service.copy}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}